import Api from '../../../../core/services/api/api';
import type {CrossSalesPartApiItem} from '../types';

/**
 * Fetches cross-sale parts for the given source part id.
 */
export async function fetchCrossSalesParts(partId: number): Promise<CrossSalesPartApiItem[]> {
    const response = await Api.getCrossSalesParts(partId);
    if (!response?.resultFlag || !response.data?.length) {
        return [];
    }
    return response.data as CrossSalesPartApiItem[];
}
